export enum OrgType {
  OWNER = "OWNER",
  LOGISTIC_PROVIDER = "LOGISTIC_PROVIDER",
  COMPANY = "COMPANY",
  CUSTOMER = "CUSTOMER",
}
